export const trimToLowercase = (string: any) => {
  return String(string || "")
    .trim()
    .toLowerCase();
};
